import axios from 'axios';
import React,{ useState,useEffect, Fragment } from 'react';
import { Tablecostdroplist, tableElecostdroplist, exhibitionview, Eleccostlistapi, exhibitionPayment } from '../../../apis/urls';
import { $ } from "react-jquery-plugin";
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import {decode} from 'html-entities'
import { useForm } from 'react-hook-form';
import ReactHtmlParser from 'react-html-parser';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { message } from 'antd';
import { exhibitionlist } from '../../../apis/urls';
import { userStore } from '../../../store/userStore';
import { id } from 'date-fns/locale';
import { Button as Buttons, Result , Modal as Modals,message as messages} from 'antd';

const PublicRegistrationExhibition =()=> {

  let navigate = useNavigate(); 
   
  const search = useLocation().search;

  const storeData = userStore()

  const exhibitionid = new URLSearchParams(search).get("event");

  const validationSchema = yup.object().shape({
    fname : yup.string().required('First Name is required'),
    lname : yup.string().required('Last Name is required'),
    email : yup.string().required('Email is required').email('Please enter valid email'),
    mailaddress : yup.string().required('Mailing address is required'),
    phone : yup.string().required('Phone is required'),
    title : yup.string().required('Contact Title is required'),
    city : yup.string().required('City is required'),
    description : yup.string().required('Description is required'),
    state : yup.string().required('State is required'),
    zipcode : yup.string().required('Zip is required'),
    table : yup.string().required('Select Number of Table is required'),
    organization : yup.string().required('Company is required'),
  });

  
    const [result, setResult] = useState('');
    
    const [costlist,setCostlist] = useState([]);
    const [tableCost,settableCost] = useState({cost: 0, table_num: 0});
    const [eleCost, setEleCost] = useState(0)
    const [paymentType, setPaymentType] = useState('CHECK')
    const [electric, setElectric] = useState(0)
    const [agreement, setAgreement] = useState(false)
    

    useEffect(()=>{
        $('body').removeClass('').addClass('sidebar-collapsed');
        setValue('state', 'GA')
        publicExhibitionView();
        tablecostlist();
        ElectricityListing();
    },[])

    const statesData = ["AL","AK","AS","AR","AZ","CA","CO","CT","DE","DC","FM","FL","GA","GU","HI","ID","IL","IN","IA","KS","KY","LA","ME","MH","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PW","PA","PR","RI","SC","SD","TN","TX","UT","VT","VI","VA","WA","WV","WI","WY"];

  const publicExhibitionView = () => {
        
    let token = "Bearer "+localStorage.getItem('token');

    const instance = axios.create({
        baseURL: exhibitionview + exhibitionid,
        timeout: 1000000,
        headers: {'authorization': token}
      });

      instance.get('').then(res => {
        setResult(res.data.data) 
          
        if(res.data.data.publish!=="PUBLISHED")
        {
          messages.error("This event is no longer accepting registration")
          setTimeout(() => {
            window.open('https://gisaschools.org/meetings-conferences/','_self');
          }, 3000);
          setResult(res.data.data) 

        }

        console.log("response is",res.data.data.publish) 
    }).catch(err => {
        console.log('err',err.message)
    })
  }

  


    const tablecostlist = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: Tablecostdroplist,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          instance.get('').then((response) =>{
            setCostlist(response?.data?.data);  
            setValue('table', response?.data?.data[0]?.id)
            settableCost({cost:response?.data?.data[0]?.cost, table_num: response?.data?.data[0]?.table_num})
          }).catch((error) =>{
            console.log('error',error.message)
          });
          
    }


    const { register, handleSubmit, formState: {errors}, setValue } = useForm({
      resolver: yupResolver(validationSchema),
    });
    

    const onSubmit = (data) => {
        const dataValues = {
          fname: data.fname,
          lname: data.lname,
          email: data.email,
          phone: data.phone,
          title: data.title,
          city: data.city,
          state: data.state,
          zipcode: data.zipcode,
          mailaddress: data.mailaddress,
          fburl: data.fburl,
          linkidinurl: data.linkedinurl,
          twitter: data.twitter,
          description: data.description,
          previous_exhibition: data.previous_exhibition,
          table_num: tableCost && tableCost.table_num,
          organization : data.organization,
          electricity: eleCost !== 0 ? "YES" : "NO",
          payment: paymentType ==="CHECK"?"PENDING":"UNPAID",
          comments: data.comments,
          status: 'ACTIVE',
          amount: paymentType ==="CHECK"?parseFloat((tableCost && tableCost?.cost + eleCost)).toFixed(2): parseFloat((tableCost && tableCost?.cost + eleCost)*103.5/100).toFixed(2),
          payment_type: paymentType
        }

        exbhitionRegister(dataValues)
    }

    const exbhitionRegister = (data) => {
      let token = "Bearer "+localStorage.getItem('token');
      const instance = axios.create({
          baseURL: `${exhibitionlist}/register/${exhibitionid}`,
          timeout: 1000000,
          headers: {'authorization': token}
        });
        instance.post('',data).then((response) =>{

          if(paymentType === 'CHECK'){
            storeData.setExhibitionData({
              name : result?.name,
              company: data?.organization,
              eleCost : eleCost,
              tableCost : tableCost,
              totalCost : parseFloat((tableCost && tableCost?.cost + eleCost)).toFixed(2)
            })
            navigate('/exhibition_check')
          }else{
            storeData.setExhibitionData({
              name : result?.name,
              eleCost : eleCost,
              tableCost : tableCost,
              totalCost : parseFloat((tableCost && tableCost?.cost + eleCost)*103.5/100).toFixed(2),
              data: response?.data?.data
            })
            navigate('/exhibition_payment')
          }
        }).catch((error) =>{
          console.log('error',error.message)
        });
        
  }

    const checkBoxSelect =(e)=> {
      if(e.target.checked){
        setEleCost(electric)
      }else{
        setEleCost(0)
      }
    }

    const ElectricityListing = () => {
        
      let token = "Bearer "+localStorage.getItem('token');
  
          const instance = axios.create({
              baseURL: `${Eleccostlistapi}/1`,
              timeout: 1000000,
              headers: {'authorization': token}
          });
  
          instance.get('').then(res => {

            setElectric(res?.data?.data?.electricty_cost)
            
          });
      }

      const acceptAgreement = (e) => {
        if(e.target.checked){
          setAgreement(true)
        }else{
          setAgreement(false)
        }
      }

return (

    <div className="wrapper">
      <aside className="right-side">
        <div className="content-area no-header">
          <div className="event-details-wrpr" style={{margin:"auto"}}>


          <div className="row">
            <div className="col-md-12">
              <div className="row event-basic-details-wrpr">
                <div className="col-md-6">
                  <div className='img-wrpr'>
                    <img src={result?.image?result?.image:null} style={{width:'100%', height:'100%', objectFit:'cover'}} width="" height="" alt="" />
                  </div>
                </div>
                <div className="col-md-6 event-basic-details">
                  <h2 style={{marginBottom:'20px'}}>{decode(result?.name)}</h2>
                  {/* <div className="date-time-seats">
                    <div className="date-time">
                        <label>Date &amp; Time</label>
                        <div className="starttime-endtime">
                            <div className="starttime">{moment(result?.start_date).format('ddd, MMM DD, YYYY hh:mm A')}</div>
                            <i className="icon-arrow-right1"></i>
                            <div className="endtime">{moment(result?.end_date).format('ddd, MMM DD, YYYY hh:mm A')}</div>
                        </div>
                    </div>
                    <div className="seats-wrpr">
                      <label>Seats</label>
                      <div className="progress" style={{color:'#fff'}}>
                        <div className="progress-bar progress-bar-striped" style={{width:'100%'}}>
                            <p style={{paddingTop:'17px', fontSize:'15px'}}>{result?.attendee_count}/{result?.max_number_attendees}</p>
                        </div>
                      </div>
                    </div>
                  </div> */}


                  <div className="fees-wrpr" style={{marginTop:'20px'}}>
                    <div className="member-fee">
                      <label style={{marginBottom:'0px'}}>Registration Deadline</label>
                      <div style={{fontSize:'14px', fontWeight: 400}} className="fee-content">
                        {moment(result?.registration_date).format('ddd, MMM DD, YYYY')}
                      </div>
                    </div>
                    <div className="non-member-fee">
                      <label style={{marginBottom:'0px'}}>Year</label>
                      <div style={{fontSize:'14px', fontWeight: 400}} className="fee-content text-right">
                        {result?.year}
                      </div>
                    </div>
                              </div>
                  <div className="event-type-wrpr">
                    <div className="conference">Exhibitor</div>
                  </div>
                  
                </div>
                <div className="col-md-12">
                  <div className="event-desc hidden-items-wrpr">
                        <p>{ReactHtmlParser(decode(result?.description))}</p>
                    </div>
                </div>
              </div>
            </div>
          </div>


            <div className="event-page-form-wrpr" style={{marginTop:'20px'}}>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row exhibition-register">

                  {/* <div className="col-md-6">
                    <label>Select your school</label>
                    <select className="form-control" value={school} onChange={(e)=>{selectSchool(e)}}>
                        <option value="0">Select school</option>
                        {result?.member_schools === "YES"?null:
                          <option>Non-member school</option>
                        }
                        {resultschool?.map((item, index)=>(
                          <option value={item.id}>{decode(item.name)}</option>
                        ))}
                    </select>
                    {schoolErr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Select a school</span>:''}
                  </div> */}


                  <div className="col-md-4">
                      <label>First Name<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter First Name" 
                        className="form-control"
                        name="fname"
                        {...register('fname')}
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.fname?.message}</p>
                  </div>
                  <div className="col-md-4">
                      <label>Last Name<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter Last Name" 
                        className="form-control"
                        name='lname'
                        {...register('lname')}
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.lname?.message}</p>
                  </div>

                  <div className="col-md-4">
                      <label>Title / Position<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter Your Title / Position" 
                        className="form-control" 
                        {...register('title')}
                        name="title"
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.title?.message}</p>
                  </div>       

                  <div className="col-md-4">
                      <label>Company Name<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter Company" 
                        className="form-control" 
                        name='organization'
                        {...register('organization')}
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.organization?.message}</p>
                  </div>

                  <div className="col-md-4">
                      <label>Email<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter Email Address" 
                        className="form-control" 
                        name='email'
                        {...register('email')}
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.email?.message}</p>
                  </div>
                  <div className="col-md-4">
                      <label>Phone<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter Phone Number" 
                        className="form-control" 
                        name='phone'
                        {...register('phone')}
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.phone?.message}</p>
                  </div>

                  <div className="col-md-12">
                    <label>Mailing Address <span style={{color: "red"}}>*</span></label>
                    <textarea
                        name='mailaddress'
                        {...register('mailaddress')}
                        placeholder="" 
                        className="form-control"
                        style={{fontSize:'13px'}}
                        rows="3" 
                        cols="50">
                    </textarea>
                    <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}} >{errors?.mailaddress?.message}</p>

                  </div>

              
                  <div className="col-md-4" >
                    <label>City<span style={{color: "red"}}>*</span></label>
                    <input 
                      type="text" 
                      placeholder="Enter City" 
                      className="form-control"
                      name='city'
                      {...register('city')}
                    />
                    <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.city?.message}</p>
                  </div>

                  <div className="col-md-4" >
                      <label>State<span style={{color: "red"}}>*</span></label>
                      {/* <input 
                        type="text" 
                        placeholder="Enter State" 
                        className="form-control"
                        {...register('state')}
                        name="state"
                      /> */}
                      <select className="form-control" {...register('state')} name="state">
                        <option value="">Select State</option>
                        {statesData?.map((item, index)=>(
                          <option key={index} value={item}>{item}</option>
                        ))}
                      </select>
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.state?.message}</p>
                  </div>

                  <div className="col-md-4" >
                      <label>Zip Code<span style={{color: "red"}}>*</span></label>
                      <input 
                        type="text" 
                        placeholder="Enter Zipcode" 
                        className="form-control"
                        name='zipcode'
                        {...register('zipcode')}
                      />
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.zipcode?.message}</p>
                  </div>

                  <div className="col-md-4" >
                      <label>Facebook URL</label>
                      <input 
                        type="text" 
                        placeholder="Enter FB URL" 
                        className="form-control"
                        name='fburl'
                        {...register('fburl')}
                      />
                  </div>

                  <div className="col-md-4" >
                      <label>Linkedin URL</label>
                      <input 
                        type="text" 
                        placeholder="Enter Linkedin URL" 
                        className="form-control"
                        name='linkedinurl'
                        {...register('linkedinurl')}
                      />
                  </div>

                  <div className="col-md-4" >
                      <label>Twitter URL</label>
                      <input 
                        type="text" 
                        placeholder="Enter Twitter URL" 
                        className="form-control"
                        name='twitter'
                        {...register('twitter')}
                      />
                  </div>

                  <div className="col-md-12" style={{marginTop:"20px"}}>
                      <label>Brief Description of Company Product or Services<span style={{color: "red"}}>*</span></label>
                      <textarea
                        style={{fontSize:'13px'}}
                        placeholder="Enter Description" 
                        className="form-control"
                        name='description'
                        {...register('description')}
                        rows="4" 
                        cols="50"
                      >
                      </textarea>
                      <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.description?.message}</p>
                  </div>

                  <div className="col-md-12" style={{marginTop:"20px"}}>
                      <label>Have you exhibited with GISA before? IF YES, List Year(s)</label>
                      <textarea 
                        placeholder="" 
                        className="form-control"
                        name='previous_exhibition'
                        style={{fontSize:'13px'}}
                        {...register('previous_exhibition')}
                        rows="2" 
                        cols="50">
                      </textarea>
                  </div>

                  <div className="col-md-12" style={{marginTop:"20px"}}>
                    <label>Special Requests</label>
                    <textarea
                        name='comments'
                        {...register('comments')}
                        placeholder="" 
                        className="form-control"
                        rows="4" 
                        cols="50">
                    </textarea>
                  </div>

                  
                  <div className="col-md-6 mt-4">
                    <label >Number of Tables<span style={{color: "red"}}>*</span></label>
                        <select 
                          name="table" 
                          {...register('table')} 
                          className="form-control"
                          {...register('table', {
                            onChange: (e) => {
                              const datas = costlist.find(item => item.id === JSON.parse(e.target.value))
                              settableCost({cost: datas?.cost, table_num: datas?.table_num})
                            },
                            onBlur: (e) => {},
                        })}
                        >
                            <option value="">Select Table</option>
                            {
                                costlist?.map((item,index)=>(
                                    item.status === 'ACTIVE'?
                                    <option key={index} value={item.id}>{item.table_num}</option> :null   
                                )
                              )
                            }
                        </select>
                        <p style={{color:'red', fontSize:'13px', fontWeight:'500', paddingTop: "5px"}}>{errors?.table?.message}</p>
                  </div>

                  <div className="col-md-6 mt-4">
                      <label >Exhibit Fee<span style={{color: "red"}}>*</span></label>
                      <input type="text" disabled className="form-control" value={`$${tableCost?.cost}`} id="name"></input>
                  </div>

                  <div className="col-md-12 mt-4" style={{display: 'inherit', flex:'auto'}}>
                      <input onChange={checkBoxSelect} style={{width:'20px', height:'20px'}} type="checkbox" id="name" />
                      <span style={{paddingLeft:'12px', fontSize:'14px'}}>Do you need electricity ( ${electric} ) ?</span>
                  </div>

                  <div className="col-md-12 mt-4" style={{display: 'inherit', flex:'auto'}}>
                      <input onChange={acceptAgreement} style={{width:'20px', height:'20px'}} type="checkbox" id="name" />
                      <span style={{paddingLeft:'12px', fontSize:'14px'}}>I agree to the <a href={result?.agreement} target='_blank'>Exhibitor Agreement</a><span style={{color: "red"}}>*</span></span>
                  </div>

                  <div className='col-md-8' />

                  <div className="col-md-4" style={{marginTop:"40px", textAlign:'right'}}>
                      <div className="row">
                        <div className="col-md-9 text-left">
                          <span className='amount-splitup'>Table Amount</span>
                        </div>
                        <div className="col-md-3 text-right">
                          <span className='amount-splitup'>${tableCost?.cost}.00</span>
                        </div>
                        { eleCost !== 0 &&
                        <Fragment>
                          <div className="col-md-9 mt-2 text-left">
                            <span className='amount-splitup'>Electricity Amount</span>
                          </div>
                          <div className="col-md-3 mt-2 text-right">
                            <span className='amount-splitup'>${eleCost}.00</span>
                          </div>
                        </Fragment>
                        }
                        <div className="col-md-9 mt-2 text-left">
                          <span className='amount-splitup'>Grand Total</span>
                        </div>
                        <div className="col-md-3 mt-2 text-right">
                          <span className='amount-splitup'>${parseFloat(((tableCost && tableCost?.cost) + eleCost)).toFixed(2)}</span>
                        </div>
                      </div>
                  </div>

                  <div className="col-md-12  mt-4">
                    <div className="workshop-form-list mt-5">
                      <div className="row">
                        <div className="col-md-12 mt-2 text-right">
                          <button
                          disabled={result.publish === 'UNPUBLISHED' || !agreement}
                          
                          onClick={()=>{setPaymentType('CHECK')}}
                          style={{marginRight:'20px', background:'#00a5c0', borderColor:'#00a5c0'}}
                          className="btn btn-primary paynow"
                          type='submit'
                          >Pay by check<i className="icon-dollar1"></i></button>
                          <button
                          // disabled={agreement?false:true}
                          disabled={result.publish === 'UNPUBLISHED' || !agreement}
                          style={{marginRight:'20px', background:'#ec3a5a', borderColor:'#ec3a5a'}}
                          onClick={()=>{setPaymentType('ONLINE')}}
                          className="btn btn-primary paynow"
                          type='submit'
                          >Pay by Credit Card<i className="icon-creditcards"></i></button>
                        </div>
                      </div>
                    </div>
                 </div>
                 <div class="col-md-1"></div>
                 <div class="col-md-11" style={{ marginTop: '10px' }}>
                    <b>For online registrations, only Visa, Mastercard, and Discover are accepted. If you want to pay by <span style={{ fontWeight: 'bold',color: 'red' }}>American Express</span>, please contact the GISA office.</b>
                </div>

                 
                </div>
              </form>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );



}


export default PublicRegistrationExhibition;